export default __webpack_public_path__ + "static/media/php.8132ef91.svg";